/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_area_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Add more numeric columns; each becomes a translucent area so overlapping series stay legible.`)
};

const es_area_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Añade más columnas numéricas; cada una se convierte en un área translúcida para que las series superpuestas se mantengan legibles.`)
};

const de_area_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Fügen Sie weitere numerische Spalten hinzu; jede wird zu einer durchscheinenden Fläche, sodass überlappende Serien lesbar bleiben.`)
};

const nl_area_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Voeg meer numerieke kolommen toe; elke kolom wordt een doorschijnend vlak zodat overlappende reeksen leesbaar blijven.`)
};

const fr_area_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Ajoutez plus de colonnes numériques ; chacune devient une aire translucide afin que les séries superposées restent lisibles.`)
};

const it_area_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Aggiungi più colonne numeriche; ciascuna diventa un'area traslucida così le serie sovrapposte restano leggibili.`)
};

const pt_br2_area_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Adicione mais colunas numéricas; cada uma se torna uma área translúcida, mantendo as séries sobrepostas legíveis.`)
};

const pt_area_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Adicione mais colunas numéricas; cada uma torna-se uma área translúcida para que as séries sobrepostas se mantenham legíveis.`)
};

const ja_area_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。数値列を追加すると、それぞれが半透明のエリアになるため、重なった系列も判読可能に保たれます。`)
};

const zh_area_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。添加更多数值列，每一列都会成为一个半透明面积，使重叠部分仍然清晰可辨。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const area_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.area_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("area_faq_a2", locale)
	if (locale === "en") return en_area_faq_a2(inputs)
	if (locale === "es") return es_area_faq_a2(inputs)
	if (locale === "de") return de_area_faq_a2(inputs)
	if (locale === "nl") return nl_area_faq_a2(inputs)
	if (locale === "fr") return fr_area_faq_a2(inputs)
	if (locale === "it") return it_area_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_area_faq_a2(inputs)
	if (locale === "pt") return pt_area_faq_a2(inputs)
	if (locale === "ja") return ja_area_faq_a2(inputs)
	return zh_area_faq_a2(inputs)
};